export class InsuranceCategory {
    id: number;
    code: string;
    name: string;
    state: any;
}